"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasRole = void 0;
const user_1 = __importDefault(require("@/data/user"));
const hasRole = function (targetRoleList) {
    if (!targetRoleList || targetRoleList.length === 0) {
        return true;
    }
    const roleList = user_1.default.info.role;
    for (let i = 0; i < roleList.length; i++) {
        const userRole = roleList[i];
        if (targetRoleList.indexOf(userRole) > -1) {
            return true;
        }
    }
    return false;
};
exports.hasRole = hasRole;
const role = {
    // 担保人
    guarantor: {
        list: ['80009R0011', '80009R0005', '80009R0041', '80009R0036'],
        edit: ['80009R0011', '80009R0005', '80009R0041', '80009R0036'],
        build: ['80009R0011', '80009R0005', '80009R0041', '80009R0036']
    },
    // 保全
    preservation: {
        list: ['80009R0041', '80009R0036'],
        edit: ['80009R0041', '80009R0036', '80009R0003', '80009R0014', '80009R0005', '80009R0137'],
        build: ['80009R0041']
    },
    // 赎回
    redeem: {
        list: ['80009R0041', '80009R0023', '80009R0036', '80009R0003', '80009R0000', '80009R0137'],
        edit: ['80009R0041', '80009R0023', '80009R0036', '80009R0003', '80009R0000', '80009R0137'],
        build: ['80009R0041', '80009R0023']
    },
    // 处置
    dispose: {
        list: ['80009R0041', '80009R0023', '80009R0036', '80009R0003', '80009R0000', '80009R0137', '80009R0019'],
        edit: ['80009R0041', '80009R0023', '80009R0036', '80009R0003', '80009R0000', '80009R0137', '80009R0019'],
        build: ['80009R0041', '80009R0023', '80009R0036']
    },
    litigation: {
        // 诉讼合同
        contract: {
            pending: ['80009R0014', '80009R0002'],
            submit: ['80009R0014', '80009R0002']
        },
        // 诉讼申请
        application: {
            list: ['80009R0014', '80009R0002', '80009R0036', '80009R0003', '80009R0000'],
            edit: ['80009R0014', '80009R0002', '80009R0036', '80009R0003', '80009R0000'],
        },
        // 诉讼记录
        log: {
            list: ['80009R0014', '80009R0002'],
        }
    },
    serviceProvider: {
        list: ['80009R0005', '80009R0036']
    },
    parkingPoint: {
        list: ['80009R0005', '80009R0036']
    },
    assignRule: {
        list: ['80009R0005', '80009R0036']
    },
    area: {
        list: ['80009R0005', '80009R0036']
    }
};
exports.default = role;
